"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPONENT_SELECTOR = exports.THEME = exports.MODE = void 0;
var MODE = {
  LIGHT: 'light',
  DARK: 'dark',
  CUSTOM: 'custom'
};
exports.MODE = MODE;
var THEME = {
  ENHO_1: 'enho_10',
  ENLIGHTEN: 'enlighten'
};
exports.THEME = THEME;
var ENPHASE_VAR_SELECTOR = 'enphase';
var COMPONENTS = ['AddDeduct', 'AddressBook', 'Backdrop', 'Badge', 'Button', 'Card', 'Checkbox', 'Chip', 'Datepicker', 'Divider', 'Drawer', 'Dropdown', 'IconButton', 'Info', 'Input', 'Link', 'Loader', 'Menu', 'Modal', 'Pagination', 'PhoneInput', 'Popover', 'Radio', 'RangeSlider', 'Select', 'Switch', 'Table', 'Tabs', 'Timepicker', 'ToastMessage', 'Tooltip', 'TopBar', 'Typography', 'UploadFile'];
var COMPONENT_SELECTOR = COMPONENTS.map(c => ({
  [c]: "".concat(ENPHASE_VAR_SELECTOR, "-").concat(c)
}));
exports.COMPONENT_SELECTOR = COMPONENT_SELECTOR;